export default __webpack_public_path__ + "static/media/product5.9158ce8e.webp";